export default {
    maptiler: {
        url: "https://api.maptiler.com/maps/basic-v2/256/{z}/{x}/{y}.png?key=8bvX5lCd2Ldla13L1zOU",
        attribution: '<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>'
    }
}